// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- RxJs
import { of } from 'rxjs/internal/observable/of';

// --- HS Code
import { SurveyUserDetailsModel } from '../../../models';
import { UserDetailsBaseService } from './user-details-base.service';

// #endregion

@Injectable({
  providedIn: 'root'
})
export class UserDetailsMockService extends UserDetailsBaseService {
  loadSurveyUserDetails(): void {}
  updateUserDetails(userDetails: SurveyUserDetailsModel) {
    return of(true)
  }
}
